<template lang="pug" src="./html/CarouselGuide.pug"></template>

<script>
  import { TweenMax, Expo, Sine } from 'gsap'
  import EventBus from './../../../event-bus'
  import GuideBase from './../../tools/guide-base'

  let STATES

  export default {
    extends: GuideBase,
    beforeCreate () {
      STATES = this.STATES
    },
    mounted () {
      this.init()
    },
    methods: {
      step1: function () {
        if (this.$store.state.mainNavOpen) {
          this.resetInit()
          return
        }
        if (this._data.state >= STATES.STEP_1) return
        this._data.state = STATES.STEP_1
        this._data.mouse.x = window.innerWidth * 0.59
        this._data.mouse.y = window.innerHeight * 0.65
        this._data.mouse.interaction = 'pan'
        EventBus.dispatchEvent('HOWTO_RUNNING', true)
        this._timer = setTimeout(this.step3, 100)
      },
      step3: function () {
        this._data.state = STATES.STEP_3

        let tx = window.innerWidth * 0.9
        let ty = window.innerHeight * 0.6

        TweenMax.to(this._data.mouse, 1.2, {x: tx, y: ty, ease: Expo.easeInOut, onComplete: this.step4})
      },
      step4: function () {
        this._data.state = STATES.STEP_4

        let tx = window.innerWidth * 0.21
        let ty = window.innerHeight * 0.62

        this._data.mouse.interaction = 'drag'
        EventBus.dispatchEvent('GUIDE.ENTER_CAROUSEL_MODE')

        TweenMax.to(this._data.mouse, 1.4, {
          x: tx,
          y: ty,
          ease: Sine.easeInOut,
          onUpdate: this.dragHiJack,
          onUpdateParams: [this._data.mouse.x],
          onComplete: this.step5,
          onCompleteParams: [this._data.mouse.x]
        })
      },
      step5: function (ox) {
        this._data.state = STATES.STEP_5

        let tx = window.innerWidth * 0.8
        let ty = window.innerHeight * 0.61

        TweenMax.to(this._data.mouse, 1.1, {
          x: tx,
          y: ty,
          ease: Sine.easeInOut,
          onUpdate: this.dragHiJack,
          onUpdateParams: [ox],
          onComplete: this.step6,
          onCompleteParams: [ox]
        })
      },
      step6: function (ox) {
        this._data.state = STATES.STEP_6

        this.dragHiJack(ox, true)

        let tx = window.innerWidth * 0.55
        let ty = window.innerHeight * 0.68

        TweenMax.to(this._data.mouse, 0.8, {
          x: tx,
          y: ty,
          ease: Sine.easeInOut,
          onComplete: this.step7
        })
      },
      step7: function () {
        this._data.state = STATES.STEP_7
        this._data.mouse.interaction = 'tap'
        this._timer = setTimeout(this.step8, 400)
      },
      step8: function () {
        this._data.state = STATES.STEP_8
        EventBus.dispatchEvent('GUIDE.EXIT_CAROUSEL_MODE')
        this._timer = setTimeout(this.step9, 500)
      },
      step9: function () {
        this._data.state = STATES.STEP_9
        this._timer = setTimeout(this.complete, 800)
        EventBus.dispatchEvent('HOWTO_COMPLETE', false)
      },
      complete: function () {
        EventBus.dispatchEvent('CAROUSEL_HOWTO_COMPLETE')
      },
      dragHiJack: function (ox, complete) {
        EventBus.dispatchEvent('HIJACK_CAROUSEL_DRAG', {
          offset: this._data.mouse.x - ox,
          complete: complete
        })
      }
    }
  }
</script>

<style lang="sass" src="./style/CarouselGuide.sass"></style>
